import {
  BaseFacet,
  BaseFacetGroup,
  RailsFlattenedFacetQuery,
  TypedRailsFacetGroup,
} from '~/typings/services/rails/facets';
import hasAnyProperties from '~/utils/hasAnyProperties';
import { getDetailById } from 'utils';
import { RailsCategory } from '~/typings/services/rails/item';

export default function filterStateToPageTitle(
  facets: BaseFacetGroup[],
  filterState: RailsFlattenedFacetQuery,
) {
  if (facets.length == 0) return '';
  if (!hasAnyProperties(filterState)) return '';

  const {
    category,
    max_price: maxPrice,
    min_price: minPrice,
    q,
    state,
    ...restDetails
  } = filterState;

  const title: string[] = [];

  if (q) {
    title.push(`"${q}"`);
  }

  Object.entries(restDetails).forEach(([slug, value]) => {
    if (Array.isArray(value) && facets[slug]) {
      title.push(
        value
          .reduce((names, v) => {
            const detail = getDetailById<BaseFacet>(facets[slug].children, v);
            return detail ? [...names, detail.name] : names;
          }, [])
          .join(', '),
      );
    }
  });

  const categoryFacet = facets.find(
    f => f.slug === 'category',
  ) as TypedRailsFacetGroup<RailsCategory>;
  if (category && categoryFacet) {
    const cat = getDetailById(categoryFacet.children, category[0]);

    if (cat) {
      title.push((cat.full_name || cat.name).replace(' > ', ' '));
    }
  }

  if (filterState.seller) {
    title.push(`${filterState.seller}'s items`);
  }

  if (minPrice && !maxPrice) {
    title.push(`$${minPrice} or more`);
  } else if (!minPrice && maxPrice) {
    title.push(`$${maxPrice} or less`);
  } else if (minPrice && maxPrice) {
    title.push(`$${minPrice} - $${maxPrice}`);
  }

  return title.join(' ');
}
